module.exports = __webpack_public_path__ + "static/img/bg.52c67e2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images1/bg.png
// module id = ZKH8
// module chunks = 1